import { initPage } from '../utils';

document.addEventListener('DOMContentLoaded', () => { initPage(); /* placeholder for home init */ });
